export enum PropertyDisplayType {
    PUBLISHED = 1,
    NOT_PUBLISHED = 2
}
export enum PropertyDisplayType {
    PUBLISHED = 1,
    NOT_PUBLISHED = 2
}
